const state = {
  theme: {},
  themes: {
    'Light Mode': {
      dotsColor: '#212338',
      chartLine: '#77798A',
      histogramBars: '#9EA1BF',
      primaryColor: '#3ACA56',
      mainFontColor: '#212338',
      secondaryFontColor: '#fff',
      chartMaximumColor: '#DADEDE',
      chartMinimumColor: '#9A9BA8',
      mainBgColor: '#fff',
      secondaryColor: '#3ACA56',
      blackColor: '#212338',
      darkGrayColor: '#666666',
      lightGrayColor: '#9B9B9B',
      extraLightGrayColor: '#E6E6E6',
      orgDropDown: '#5C5E6D',
      headerBg: '#212338',
      selectedNav: '#3ACA56',
      breadcrumb: '#9B9B9B',
      cardTextColor: '#212338',
      topTitle: '#212338',
      tabelEnteries: '#212338',
      settingBackground: '#fff',
      settingBlackColor: '#212338',
      settingDarkGrayColor: '#666666',
      settingExtraLightGrayColor: '#E6E6E6',
      inputLabel: '#666666',
      iconColor: 'black'
    },
    'Dark Mode': {
      dotsColor: '#212338',
      chartLine: '#77798A',
      histogramBars: '#C5C9D9',
      primaryColor: '#67BFD6',
      mainFontColor: '#fff',
      secondaryFontColor: '#212338',
      chartMaximumColor: '#DADEDE',
      chartMinimumColor: '#9A9BA8',
      mainBgColor: '#000000',
      secondaryColor: '#5096A8',
      blackColor: '#fff',
      darkGrayColor: '#fff',
      lightGrayColor: '#9B9B9B',
      extraLightGrayColor: '#000000',
      orgDropDown: '#fff',
      headerBg: '#000000',
      selectedNav: '#3ACA56',
      breadcrumb: '#fff',
      cardTextColor: '#000000',
      topTitle: '#000000',
      tabelEnteries: '#000000',
      settingBackground: '#fff',
      settingBlack: '#000000',
      settingDarkGray: '#666666',
      settingExtraLightGrayColor: '#E6E6E6',
      inputLabel: '#666666',
      iconColor: 'white'
    }
    // 'Purple Mode': {
    //   dotsColor: '#33565f',
    //   primaryColor: '#67BFD6',
    //   secondaryColor: '#5096A8',
    //   blackColor: '#fff',
    //   darkGrayColor: '#fff',
    //   lightGrayColor: '#9B9B9B',
    //   extraLightGrayColor: 'purple',
    //   orgDropDown: '#fff',
    //   headerBg: 'purple',
    //   selectedNav: '#666666',
    //   breadcrumb: '#fff',
    //   cardTextColor: 'purple',
    //   topTitle: 'purple',
    //   tabelEnteries: 'purple',
    //   settingBackground: '#fff',
    //   settingBlack: 'purple',
    //   settingDarkGray: '#666666',
    //   settingExtraLightGrayColor: '#E6E6E6',
    //   inputLabel: '#666666',
    //   iconColor: 'white'
    // }
  },
  treemap: {
    light: 'rgba(226, 239, 247, 1)',
    medium: 'rgba(173, 192, 202, 1)',
    dark: 'rgba(33, 35, 56, 1)'
  }
}

const getters = {
  theme: state => {
    return state.theme
  }
}

const actions = {
}

const mutations = {
  changeTheme (state, value) {
    state.theme = state.themes[value]
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  name: 'colorPaletteServices'
}
